@for (tag of tags(); track tag.label) {
  <span> <i class="mdi mdi-{{ tag.icon }}"></i> {{ tag.label }} </span>
}
